{
  "defaultDSIntermediates": false,
  "enableAsyncDefaultPredictor": false,
  "enableCandidateViewOptions": false,
  "enableCandidateToMaterial": false,
  "enableCombinedLabelsIngredientsTabs": false,
  "enableCreateRawMaterial": false,
  "enableCreateRawMaterialFromPDF": false,
  "enableFeatureImpactPlots": false,
  "enableSearchSpaceConstraintsFromTrainingData": false,
  "enableFeatureCustomization": false,
  "enableFullStory": false,
  "enableInsightsCopilotDemo": false,
  "enableModelAssistant": true,
  "enableFastSearchSpaceValidation": false,
  "enableModelExplorerFlatFormulation": false,
  "enablePredictionInsights": false,
  "enablePrivateDocuments": false,
  "enableProductionHSBeacon": false,
  "enableSentry": true,
  "enableSlProgressBranchSummary": false,
  "enableSnapshotsAsDataSources": false,
  "enableSupportChat": false,
  "enableZendesk": false,
  "enforceDataManagerDataset": false,
  "maxFormulationDesignIngredients": 128,
  "maxFormulationNonzeroIngredients": 32,
  "maxMaterialsPaginationPageSize": 500,
  "maxMLModelOutputs": 32,
  "maxTerminalMaterialsInAnalysisWorkflowQuery": 5000,
  "predictorEvaluationResultDownsamplingLimit": 10000,
  "plotsPerAnalysisWorkflow": 10,
  "showSearchListCreation": false,
  "useTestApexConfig": false,
  "trialTermsUrl": ""
}
